import { Aperture } from "lucide-react";

// A small, on-brand loading indicator: rotating aperture + optional label.
// Feels friendlier than a bare "Loading…" and reinforces the photography theme.
export default function ApertureLoader({ label = "Loading…" }) {
  return (
    <div
      className="min-h-[60vh] flex flex-col items-center justify-center gap-4"
      data-testid="aperture-loader"
    >
      <Aperture
        className="aperture-spin w-9 h-9 text-[#6B0F1A]"
        strokeWidth={1.5}
      />
      <div className="font-mono-tag text-[10px] text-[#78584B] tracking-wider">
        {label}
      </div>
    </div>
  );
}
